import { tsGetSampleRun } from '../../Typescript/API_Response'

export function sampleRunDisabled(sampleRun: tsGetSampleRun | undefined) {
  return !sampleRun || sampleRun.runInfo.Status !== 'PEN'
}

export function addSamplePath(criteria: string) {
  switch (criteria) {
    case '1':
      return '/stuart/sample/add/rack'
    case '5':
      return '/stuart/sample/add/environment'
    default:
      return '/stuart/sample/add/container'
  }
}
